import Wysiwyg from './Wysiwyg';
export default Wysiwyg;